import React, { useState, useEffect } from "react";
import { MessageCircle, Phone, TrendingUp, Bell, Inbox } from "lucide-react";
import api from "@/lib/apiClient";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function LeadsInbox({ business }) {
  const [leads, setLeads] = useState([]);
  const [notifs, setNotifs] = useState([]);
  const [active, setActive] = useState(null);
  const bid = business.id;

  const load = async () => {
    const [l, n] = await Promise.all([
      api.get(`/businesses/${bid}/leads`),
      api.get(`/businesses/${bid}/notifications`),
    ]);
    setLeads(l.data); setNotifs(n.data);
  };
  useEffect(() => { load(); }, [bid]);

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-3">
        <h3 className="font-display font-semibold flex items-center gap-2"><Inbox className="w-4 h-4" /> Leads Masuk</h3>
        <div className="rounded-2xl border border-border bg-card overflow-hidden">
          {leads.length === 0 ? (
            <p className="text-sm text-muted-foreground p-8 text-center">
              Belum ada lead. Coba chat di widget dengan kata "mau beli" atau kirim nomor HP untuk memicu lead.
            </p>
          ) : (
            <Table data-testid="table-leads-inbox">
              <TableHeader><TableRow>
                <TableHead>Customer</TableHead><TableHead>Intent</TableHead>
                <TableHead>Pesan</TableHead><TableHead></TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {leads.map((l) => (
                  <TableRow key={l.id}>
                    <TableCell>
                      <p className="font-medium">{l.customer_name}</p>
                      <p className="text-xs text-muted-foreground font-mono">{l.phone || "-"}</p>
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline" className="bg-accent/10 text-accent border-accent/20">
                        <TrendingUp className="w-3 h-3 mr-1" /> {l.intent_score}%
                      </Badge>
                    </TableCell>
                    <TableCell className="text-xs text-muted-foreground max-w-[220px] truncate">{l.message}</TableCell>
                    <TableCell className="flex gap-1.5">
                      <Button size="sm" variant="outline" data-testid="btn-view-transcript" onClick={() => setActive(l)}>
                        <MessageCircle className="w-3.5 h-3.5" />
                      </Button>
                      {l.phone && (
                        <a href={`https://wa.me/${l.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer"
                          data-testid="btn-open-wa-chat">
                          <Button size="sm" className="bg-[#25D366] hover:bg-[#20bd5a] text-white">
                            <Phone className="w-3.5 h-3.5" />
                          </Button>
                        </a>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>

      <div className="space-y-3">
        <h3 className="font-display font-semibold flex items-center gap-2"><Bell className="w-4 h-4" /> Log Notifikasi WhatsApp</h3>
        <div className="space-y-2 max-h-[520px] overflow-y-auto" data-testid="wa-notification-log">
          {notifs.length === 0 ? (
            <p className="text-sm text-muted-foreground rounded-xl border border-dashed p-4">Belum ada notifikasi terkirim.</p>
          ) : notifs.map((n) => (
            <div key={n.id} className="rounded-xl border border-border bg-card p-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-[#25D366] flex items-center gap-1"><Phone className="w-3 h-3" /> {n.to || "admin"}</span>
                <Badge variant="outline" className="text-[10px]">{n.status}</Badge>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{n.text}</p>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-muted-foreground">
          Notifikasi dikirim via <b>Twilio WhatsApp</b> bila kredensial diisi (backend .env). Bila kosong, otomatis mode SIMULASI (log).
        </p>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="lead-transcript-modal">
          <DialogHeader><DialogTitle>Transkrip — {active?.customer_name}</DialogTitle></DialogHeader>
          <div className="space-y-2 max-h-[400px] overflow-y-auto">
            {active?.transcript?.map((t, i) => (
              <div key={i} className="text-sm rounded-lg bg-muted px-3 py-2">
                <span className="text-xs uppercase tracking-wide text-muted-foreground">{t.role}</span>
                <p>{t.content}</p>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
